<template>
    <transition name="slider">
        <div class="cmp_mobile-sideBar">
            <div class="mobile-sideBar-content" v-clickoutside="handleClickOutside">
                <ul class="menu_list">
                    <li
                        v-for="item in menuList"
                        :key="item.key"
                        :class="[activeMenu === item.key ? 'activeMenuClass' : '', 'menu_item']"
                        @click="handleMenuChange(item.key)">
                        {{item.name}}
                    </li>
                </ul>
                <div class="contact">
                    <h3 class="subTitle">在微信获取更多营销资源</h3>
                    <img :src="require('../assets/images/qrCode.png')" alt="">
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import {menuList} from '@/modules/mobile/constants/home';
export default {
    name: 'cmp_mobile-sideBar',
    props: {
        activePath: {
            type: String,
            default: () => 'home'
        }
    },
    data() {
        return {
            menuList: menuList,
            activeMenu: 'home'
        };
    },
    components: {},
    watch: {
        activePath: {
            handler(val) {
                if (val) {
                    let arr = val.split('/');
                    let path = arr[arr.length - 1];
                    this.activeMenu = path;
                }
            },
            immediate: true
        }
    },
    mounted() {},
    methods: {
        handleMenuChange(key) {
            this.activeMenu = key;
            // this.$router.push(`/business/mobile/${key}`);
            window.location.href = `/business/mobile/${key}`;
            this.$emit('openSideBar', false);
        },
        handleClickOutside() {
            // this.$emit('openSideBar', false);
        }
    }
};
</script>

<style scoped lang="scss">
.cmp_mobile-sideBar {
    background: rgba($color: #000000, $alpha: 0.6);
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: 4000;
    top: mvw(50);
    bottom: 0;
    left: 0;
    right: 0;
    .mobile-sideBar-content {
        width: mvw(250);
        height: 100%;
        background: #FFFFFF;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 1111;
        border: 1px solid #D0DBFE;
        padding: 0 mvw(35);
        box-sizing: border-box;
        .menu_list {
            margin-bottom: mvw(40);
            .menu_item {
                padding: mvw(18) 0;
                border-bottom: 1px solid #D0DBFE;
                text-align: left;
                font-family: PingFangSC-Semibold;
                font-weight: 700;
                font-size: mvw(14);
                color: #374567;
                letter-spacing: 0;
                line-height: mvw(14);
            }
            .activeMenuClass {
                color: #0067FF;
            }
        }
        .contact {
            text-align: left;
            .subTitle {
                font-family: PingFangSC-Semibold;
                font-size: mvw(12);
                color: #8897AF;
                letter-spacing: 0;
                line-height: mvw(12);
                margin-bottom: mvw(12);
            }
            &>img {
                width: mvw(130);
                height: mvw(130);
                border: 1px solid #D0DBFE;
                border-radius: 6px;
            }
        }
    }
}
.slider-enter-active, .slider-leave-active {
    transition: opacity .6s ease;
}
.slider-enter, .slider-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/mobile/components/sideBar.vue